// MUI components
import { useContext, useEffect } from 'react'
import { IntakeContext } from '../context/IntakeContext'
import { useFormDebounce } from 'hooks/useFormDebounce'
import { renderMuiFormField } from 'utils/forms/renderMuiFormField'
import FamilyDependents from 'admin/components/FamilyDependents'
import { Box, Grid, Typography } from '@mui/material'
import { useFieldFocus } from 'context/FieldFocusContext'

const OnboardingFamilyDependents = () => {
  const { intakeState, updateIntakeStateAtKey } = useContext(IntakeContext)
  const { updateIntakeStateAndSubmit } = useFormDebounce()
  const fieldId = 'dependentHelp'
  const helpText =
    'We need to know this for FEGLI, Health Insurance, and Beneficiary planning.'
  const { handleFocus, handleBlur, registerHelpField } = useFieldFocus()
  useEffect(() => {
    registerHelpField(fieldId, helpText)
  }, [fieldId])
  return (
    <Box sx={{ textAlign: 'left' }}>
      <Box mb={1}>
        <Typography variant="h4" fontSize={{ xs: '20px', sm: '24px' }}>
          Let&apos;s talk about the rest of your family!
        </Typography>
      </Box>
      <Box component="form" py={3}>
        <Grid container>
          <Grid container columnSpacing={3}>
            <Grid item xs={12} mb={4}>
              <Box
                mt={2}
                mb={2}
                onMouseEnter={(e) => handleFocus(fieldId, e.currentTarget)}
                onMouseLeave={() => handleBlur()}
              >
                <Typography variant="body1Medium">
                  Add any Children that you have
                </Typography>
              </Box>
              {/* {renderMuiFormField({
                autoFocus: false,
                id: 'familyChildren',
                label: 'Number of children',
                placeholder: intakeState.familyChildren,
                inputType: 'int',
                value: intakeState.familyChildren,
                onChange: updateIntakeStateAndSubmit((familyChildren) =>
                  updateIntakeStateAtKey({ familyChildren })
                ),
                maxValue: 12,
              })} */}
              <FamilyDependents
                numDependents={intakeState?.familyChildren || 0}
                initialDependents={intakeState?.familyDependents || []}
                updateIntakeStateAndSubmit={updateIntakeStateAndSubmit}
                updateIntakeStateAtKey={updateIntakeStateAtKey}
              />
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}
export default OnboardingFamilyDependents
